import ILoggingListener from "./ILoggingListener";
import LocalLogStore from "./LocalLogStore";

export default class LocalStoreLogger implements ILoggingListener{

    private readonly store: LocalLogStore = null;

    constructor(store: LocalLogStore) {
        this.store = store;
    }

    public logMessage(message: string) {
        if(this.store !== null) {
            this.store.addMessage(message);
        }
    }

}


// WEBPACK FOOTER //
// ./src/logging/LocalStoreLogger.ts